const ImageRenderer = ({ src, alt }) => {
  const [altText, ...options] = alt.split("|").map((item) => item.trim());

  const widthMatch = options.find((opt) => opt.startsWith("width="));
  const maxWidthMatch = options.find((opt) => opt.startsWith("maxWidth="));
  const responsive = options.includes("responsive=true");
  const isCentered = options.includes("center=true");

  const width = widthMatch ? widthMatch.split("=")[1] + "px" : "300px";
  const maxWidth = maxWidthMatch
    ? maxWidthMatch.split("=")[1] + "px"
    : undefined;

  const widthStyle = responsive
    ? { width: "100%", maxWidth: maxWidth || "100%", height: "auto" }
    : { width, maxWidth, height: "auto" };

  const image = (
    <img
      src={src}
      alt={altText}
      loading="lazy"
      decoding="async"
      style={{
        ...widthStyle,
        display: "block",
        borderRadius: 8,
      }}
    />
  );

  return isCentered ? (
    <div style={{ display: "flex", justifyContent: "center" }}>{image}</div>
  ) : (
    image
  );
};

export default ImageRenderer;
